import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtButton from "../../components/NtButton";
import { useTheme } from "../../context/ThemeContext";
function NtOnboardingFooter({
  steps = [],
  currentStep,
  canContinue = true,
  loading = false,
  finishLabel = "Complete signup",
  onBack,
  onSkip,
  onContinue,
  onExit,
  exitLabel = "Exit wizard",
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const total = steps.length;
  const step = steps[currentStep];
  const isFirst = currentStep === 0;
  const isLast = currentStep === total - 1;
  const nextStep = steps[currentStep + 1];

  const continueLabel = isLast
    ? finishLabel
    : nextStep
    ? `Continue · ${nextStep.title} →`
    : "Continue →";

  return (
    <View style={styles.bar}>
      <View style={styles.left}>
        <NtText style={styles.progress}>
          Step {currentStep + 1} of {total} · {step?.title}
        </NtText>
        {onExit ? (
          <NtButton
            variant="secondary"
            text={exitLabel}
            icon="close"
            onPress={onExit}
            size="sm"
          />
        ) : null}
      </View>
      <View style={styles.actions}>
        {!isLast && step.canSkip !== false ? (
          <NtButton variant="ghost" text="Skip for now" onPress={onSkip} />
        ) : null}
        {!isFirst ? (
          <NtButton variant="secondary" text="Back" onPress={onBack} />
        ) : null}
        <NtButton
          variant="primary"
          text={continueLabel}
          isLoading={loading}
          onPress={canContinue && !loading ? onContinue : null}
          containerStyle={[styles.primary, !canContinue && styles.primaryDisabled]}
          textStyle={!canContinue ? styles.primaryTextDisabled : null}
        />
      </View>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    bar: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingHorizontal: 56,
      paddingVertical: 18,
      backgroundColor: t.surface,
      borderTopWidth: 1,
      borderTopColor: t.border,
    },
    left: { flexDirection: "row", alignItems: "center", gap: 14 },
    progress: { fontSize: 12, color: t.textDim, fontWeight: "500" },
    actions: { flexDirection: "row", alignItems: "center", gap: 8 },
    primary: {
      paddingHorizontal: 22,
      paddingVertical: 13,
    },
    primaryDisabled: {
      backgroundColor: t.surface3,
      borderColor: t.border,
    },
    primaryTextDisabled: { color: t.textMute },
  });

export default NtOnboardingFooter;
